import { ABP, ListService, PagedResultDto, PermissionService } from '@abp/ng.core';
import { Confirmation, ConfirmationService } from '@abp/ng.theme.shared';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CertService } from '@proxy/cert-report-service';
import { AssetDetailsDto, AssetService } from '@proxy/register-service/assets';
import { CategoryService } from '@proxy/register-service/categories';
import { RecurrenceType } from '@proxy/servicing-service/inspection-types';
import { InspectionDetailsDto, InspectionState } from '@proxy/servicing-service/inspections';
import { InspectionService } from '@proxy/servicing-service/inspections/inspection.service';
import fileDownload from 'js-file-download';
import { filter, switchMap } from 'rxjs';

@Component({
  selector: 'app-historical-events',
  templateUrl: './historical-events.component.html',
  styleUrls: ['./historical-events.component.scss'],
})
export class HistoricalEventsComponent implements OnInit {
  @Input() asset: AssetDetailsDto;

  historicalData: PagedResultDto<InspectionDetailsDto> = {
    items: [],
    totalCount: 0,
  };
  RecurrenceType = RecurrenceType;
  selected?: InspectionDetailsDto;
  status: any;

  constructor(
    public readonly router: Router,
    public readonly list: ListService,
    public readonly service: InspectionService,
    public readonly assetService: AssetService,
    public readonly categoryService: CategoryService,
    private readonly certService: CertService,
    private readonly permissionService: PermissionService,
    private readonly confirmation: ConfirmationService
  ) {}

  ngOnInit() {
    const getData = (query: ABP.PageQueryParams) =>
      this.service.getList({
        ...query,
        isGroup: false,
        assetId: this.asset.id,
        isHistorical: true,
        maxResultCount: 50,
        term: query.filter,
      });

    const setData = (list: PagedResultDto<InspectionDetailsDto>) => {
      this.historicalData = list;
      this.historicalData.items
        .filter(q => q.assetPictureUrl || q.categoryPictureUrl)
        .forEach(i =>
          this.getPicture(
            i.assetPictureUrl ? i.assetId : i.categoryId,
            i.assetPictureUrl ? 'asset' : 'category'
          )
        );
    };

    this.list.hookToQuery(getData).subscribe(setData);
  }

  onGetReport(record: InspectionDetailsDto) {
    this.certService.getCert(record.id).subscribe(resp => {
      fileDownload(resp.historicalData, resp.fileName, resp.contentType);
    });
  }
  onRepeat(record: InspectionDetailsDto) {
    this.selected = undefined;
    this.router.navigate(['/inspections/create'], {
      queryParams: { assetId: record.assetId, typeId: record.typeId },
    });
  }

  onDelete(record: InspectionDetailsDto) {
    this.confirmation
      .warn('ServicingService::DeleteConfirmationMessage', 'ServicingService::AreYouSure', {
        messageLocalizationParams: [],
      })
      .pipe(
        filter(status => status === Confirmation.Status.confirm),
        switchMap(() => this.service.delete(record.id))
      )
      .subscribe(this.list.get);
  }

  onView(record: InspectionDetailsDto) {
    this.router.navigate(['/inspections/details'], {
      queryParams: { id: record.id, assetId: record.assetId, typeId: record.typeId },
    });
  }

  isDeletable(record: InspectionDetailsDto) {
    return (
      record.state === InspectionState.Draft &&
      record.isActive &&
      this.permissionService.getGrantedPolicy('ServicingService.Inspections.Delete')
    );
  }

  getPicture(id: string, type: 'asset' | 'category') {
    if (type === 'asset') {
      this.assetService.getPicture(id).subscribe(image => this.loadPictureFromBlob(id, image));
    } else if (type === 'category') {
      this.categoryService.getPicture(id).subscribe(image => this.loadPictureFromBlob(id, image));
    }
  }

  private loadPictureFromBlob(id, blob) {
    if (blob) {
      if (blob.size > 102400) {
        this.confirmation.info(`RegisterService::InvalidImageSize`, 'Image Upload', {
          cancelText: 'OK',
          hideYesBtn: true,
        });
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          this.historicalData.items.find(q => q.assetId == id || q.categoryId == id).pictureUrl =
            reader.result as string;
        };
        reader.readAsDataURL(blob);
      }
    }
  }
}
